export default __webpack_public_path__ + "static/media/icon.70f5996c.svg";